import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { OrgRole } from '../../models/org-role';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { NoDataRow, TableGroup } from '../../../../shared/models/ui/table-group';
import { SelectionModel } from '@angular/cdk/collections';
import { ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { OrganizationService } from '../../../../internal-user/customer-management/services/organization.service';
import { ToastService } from '../../../../shared/services/toast.service';
import { OrgUser } from '../../models/org-user';
import { AuthService } from '../../../../auth/auth.service';
import { UserService } from '../../services/user.service';
import { RoleService } from '../../services/role.service';
import { forkJoin, throwError } from 'rxjs';
import { SiteService } from 'src/app/external-user/inventory/services/site.service';
import { Site } from 'src/app/external-user/inventory/models/site';
import { OrgUsersAndRoles } from '../../models/org-users-with-roles';
import { OrgUserRoles } from '../../models/org-user-roles';
import { AuthorizationService } from 'src/app/internal-user/customer-management/services/authorization.service';
import { Role } from '../../../../shared/models/auth/role';
import { ReportService } from 'src/app/external-user/reports/services/report.service';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { LoggerService } from 'src/app/shared/services/logger.service';
import { Sort } from '@angular/material/sort';
import { OrgLevelAdminService } from 'src/app/internal-user/customer-management/services/orgleveladmin.service';
import { OrgUserRole } from '../../models/org-user-role';
import { Country } from '../../models/country';
import { UserCountry } from '../../models/user-country';
import { CountryService } from '../../services/country.service';
import { ManagedUserInfo } from '../../models/managed-user-info';
import { UserCountries } from '../../models/user-countries';

interface TableRow extends TableGroup, NoDataRow, OrgUsersAndRoles {
  index?: number;
}

interface FilterData {
  text?: string;
  roleId?: string;
  organizationId?: string;
}

interface FilterRole {
  roleId: string;
  name: string;    
  description: string;
}

@Component({
    selector: 'app-user-management',
    templateUrl: './user-management.component.html',
    styleUrls: ['./user-management.component.scss'],
    standalone: false
})
export class UserManagementComponent implements OnInit {
  selectedRoleId: string = '';
  parentOrganization: Site = null;
  sites: Site[] = [];
  selectedSite: Site = null;
  selectedSiteId: string = '';
  availableSites: Site[] = [];
  availableSitesForEditForm : Site[] = [];

  constructor(
    private route: ActivatedRoute,
    private ngxLoader: NgxUiLoaderService,
    private authService: AuthService,
    private userService: UserService,
    private roleService: RoleService,
    private authorizationService: AuthorizationService,
    private organizationService: OrganizationService,
    private toastService: ToastService,
    private reportService: ReportService,
    private loggerService: LoggerService,
    private orgLevelAdminService:OrgLevelAdminService,
    private siteService: SiteService,
    private readonly countryService: CountryService
  ) {
    this.formGroup = new FormGroup({
      userLastName: new FormControl('', [Validators.required, Validators.maxLength(50), Validators.pattern('[a-zA-Z]+([-\' ][a-zA-Z]+)*')]),
      userFirstName: new FormControl('', [Validators.required, Validators.maxLength(50), Validators.pattern('[a-zA-Z]+([-\' ][a-zA-Z]+)*')]),
      userEmail: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')]),      
      roleId: new FormControl('', [Validators.required]),
      siteId: new FormControl(''),
      countryIds: new FormControl<number[]>([]),
    });

    this.editUserFormGroup = new FormGroup({
      name: new FormControl(''),
      email: new FormControl(''),
      roleId: new FormControl('', [Validators.required]),
      siteId: new FormControl('', [Validators.required]),
      countryIds: new FormControl<number[]>([]),
    });

    this.activeGroup = { groupName: 'Active Users', htmlId: 'UserManagementActiveUsers', expanded: true };
    this.inActiveGroup = { groupName: 'Inactive Users', htmlId: 'UserManagementInactiveUsers', expanded: true };
  }

  /** Whether the number of selected elements matches the total number of rows. */
  get isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.selectableRows.length;
    return numSelected === numRows;
  }

  private get selectableRows() {
    return (this.dataSource.data || [])
      .filter((row) => 'userId' in row && row.enabled);
  }

  isPM = false;
  isIM = false;
  isCDDBViewer = false;
  isOrgAdmin = false;
  orgType: string;  
  isResendInvitationVisible = false;
  isResetPasswordVisible = false;
  isSelected = '';
  isFilterVisible = true;
  isEmailExist = false;
  roles: OrgRole[] = [];
  filterRoles: FilterRole[] = [];   // roles for the top filter dropdown
  userList: OrgUsersAndRoles[] = [];
  activeUsers: OrgUsersAndRoles[] = [];
  inActiveUsers: OrgUsersAndRoles[] = [];
  @Input() isGearIconClicked = false;
  @Input() isOrgLevel = false;
  paramOrgId: string;
  paramParentOrgId: string;
  showCountries: boolean = true;
  addingCountries: boolean = false;
  editingCountries: boolean = false;
  countriesList: Country[] = [];
  userCountriesList: UserCountry[] = [];

  isUserTypeWithCountries: boolean = false;
  availableAddCountries: Country[] = [];
  availableEditCountries: Country[] = [];

  displayedColumns: string[];
  editingColumns: string[];
  dataSource = new MatTableDataSource<TableRow>([]);
  selection = new SelectionModel<OrgUsersAndRoles>(true, []);
  activeGroup: TableGroup;
  inActiveGroup: TableGroup;
  filter: FilterData;
  loggedEmail: string;
  formGroup: FormGroup;
  @ViewChild('formDirective', { static: false }) private formDirective: NgForm;

  editingUser: OrgUsersAndRoles;
  editUserFormGroup: FormGroup;
  inactivatedUser: OrgUsersAndRoles;
  inactivatedUserPanelTimeout: any = null;

  /** Get the selected organization and load the roles and list of users */
  ngOnInit() {
    this.isOrgLevel = this.orgLevelAdminService.getOrgLevelRowValue();
    this.dataSource.filterPredicate = this.customFilterPredicate.bind(this);

    const ngxLoaderKey = 'load-profile';
    this.ngxLoader.start(ngxLoaderKey);

    this.authService.profile$.subscribe((profile) => {
      this.setProfileProperties(profile);
  
      this.initializeColumns();
      this.updateAddFormValidation();
      this.showResendInvtnAndResetPwd();

      if (this.isGearIconClicked) {
        this.handleGearIconClicked(profile, ngxLoaderKey);
      }
      else{
        this.handleCustomerManagementFlow(ngxLoaderKey);
      }
    }, (response) => this.toastService.stopLoadingAndShowError(response, '', ngxLoaderKey));
  }

  private setProfileProperties(profile) {
    this.loggedEmail = profile.email;
    this.orgType = profile.orgType;
    this.isPM = profile.hasRole(Role.pharmacy);
    this.isIM = profile.hasRole(Role.implementationMgr);
    this.isOrgAdmin = profile.hasRole(Role.orgAdmin);
    this.isCDDBViewer = profile.hasRole(Role.ert)
    
    if (this.isGearIconClicked && this.orgType === 'Internal') {
      this.isOrgLevel = false;
    } else if (this.isGearIconClicked && this.isOrgAdmin) {
      this.isOrgLevel = true;
    }

    if (this.isOrgLevel
        || this.orgType === 'External'
        || !this.isGearIconClicked) {
      this.showCountries = false;
    }
  }

  private handleGearIconClicked(profile, ngxLoaderKey: string) {
    this.paramOrgId = profile.organizationId;
    this.paramParentOrgId = profile.parentOrganizationId;
    
    this.initializeBasedOnOrgLevel(ngxLoaderKey);
  }

  private handleCustomerManagementFlow(ngxLoaderKey: string) {
    this.route.parent.params.subscribe(({ id }) => {
        this.organizationService.getByID(id).subscribe((org) => {
            this.paramOrgId = org.organizationId;
            this.paramParentOrgId = org.parent_Account_Id;

            this.initializeBasedOnOrgLevel(ngxLoaderKey);
        });
    });
  }

  private initializeBasedOnOrgLevel(ngxLoaderKey: string) {
    if (this.isOrgLevel) {
      this.setupRoleChangeListener();
      this.loadOrganizationAndSites(ngxLoaderKey);
    } else {
      this.setupRoleChangeCountryListener();
      this.loadUsersRoles(ngxLoaderKey);
      this.loadCountryInfo(ngxLoaderKey);
    }
  }

  private buildFilterRolesFromUsers() {
    const map = new Map<string, FilterRole>();
    const users = this.userList ?? [];

   for (const u of users) {
     if (!map.has(u.roleId)) {
       map.set(u.roleId, {
         roleId: u.roleId,
         name: u.roleName,
         description: u.roleDescription
       });
     }
   }

    this.filterRoles = Array.from(map.values())
      .sort((a, b) => a.description.localeCompare(b.description));
  }

  initializeColumns() {
    this.displayedColumns = ['name', 'email', 'role'];
    this.editingColumns = ['name', 'email', 'editRole'];

    if (this.isOrgLevel) this.displayedColumns.push('site');
    if (this.isOrgLevel) this.editingColumns.push('editSite');

    if (this.showCountries) this.displayedColumns.push('countries');
    if (this.showCountries) this.editingColumns.push('editCountries');
    
    this.displayedColumns.push('actions');
    this.editingColumns.push('editActions');
  }

  loadOrganizationAndSites(ngxLoaderKey) {
    forkJoin({
      parentOrganization: this.organizationService.getByID(this.paramParentOrgId),
      sites: this.siteService.getSitesForParentOrg(this.paramParentOrgId)
    }).subscribe(
      ({ parentOrganization, sites }) => {
        this.parentOrganization = parentOrganization;
        this.sites = sites.filter(site => site.enabled === true);
        this.availableSites = this.sites;
        this.availableSitesForEditForm = this.sites;
        this.selectedSiteId = this.parentOrganization.organizationId;
        this.loadUsersRoles(ngxLoaderKey);
      },
      (error) => this.toastService.stopLoadingAndShowError(error, 'Unable to load organization and sites!', ngxLoaderKey)
    );
  }

  setupRoleChangeListener() {
    this.formGroup.get('roleId').valueChanges.subscribe((roleId) => {
      this.updateAvailableSites(roleId, 'add');
      this.updateAvailableCountries(roleId, 'add');
    });
  
    this.editUserFormGroup.get('roleId').valueChanges.subscribe((roleId) => {
      this.updateAvailableSites(roleId, 'edit');
      this.updateAvailableCountries(roleId, 'edit');
    });
  }

  setupRoleChangeCountryListener() {
    this.formGroup.get('roleId').valueChanges.subscribe((roleId) => {
      this.updateAvailableCountries(roleId, 'add');
    });
  
    this.editUserFormGroup.get('roleId').valueChanges.subscribe((roleId) => {
      this.updateAvailableCountries(roleId, 'edit');
    });
  }
  
  updateAvailableSites(roleId: string, formType: 'add' | 'edit') {
    const selectedRole = this.roles.find(role => role.roleId === roleId);
    const sites = selectedRole?.name === 'OrgAdmin' ? [this.parentOrganization] : this.sites;
  
    if (formType === 'add') {
      const previousSites = this.availableSites; // Store the previous value
      this.availableSites = sites;
  
      // Reset siteId if the available sites have changed
      if (previousSites !== this.availableSites) {
        this.formGroup.get('siteId').setValue(selectedRole?.name === 'OrgAdmin' ? this.parentOrganization.organizationId : '');
      }
    } else {
      const previousSites = this.availableSitesForEditForm; // Store the previous value
      this.availableSitesForEditForm = sites;
  
      // Reset siteId for the edit form if the available sites have changed
      if (previousSites !== this.availableSitesForEditForm) {
        this.editUserFormGroup.get('siteId').setValue(selectedRole?.name === 'OrgAdmin' ? this.parentOrganization.organizationId : '');
      }
    }
  }
  
  updateAvailableCountries(roleId: string, formType: 'add' | 'edit') {
    const selectedRole = this.roles.find(role => role.roleId === roleId);
    this.isUserTypeWithCountries = selectedRole?.name === 'RPO';
    let availableCountries: Country[] = [];
    
    // get available countries by role
    if (this.isUserTypeWithCountries) {
      availableCountries = this.countriesList;
    } else {
      availableCountries = [];
    }

    // edit form countries list
    if (formType === 'add') {
      this.availableAddCountries = availableCountries;
      if (!this.isUserTypeWithCountries) {
        this.addingCountries = false;
      }
      else {
        this.addingCountries = true;
      }
    } else {
      this.availableEditCountries = availableCountries;
      if (!this.isUserTypeWithCountries) {
        this.editingCountries = false;
      }
      else {
        this.editingCountries = true;
      }
    }
  }

  updateAddFormValidation() {
    const siteIdControl = this.formGroup.get('siteId');
    if (this.isOrgLevel) {
      siteIdControl.setValidators([Validators.required]);
    } else {
      siteIdControl.clearValidators();
    }
    siteIdControl.updateValueAndValidity();
  }

  onSiteFilterChange() {
    this.loadUsers();
  }

  loadUsersRoles(ngxLoaderKey) {
    this.roleService.getRolesForOrg(this.paramParentOrgId, this.orgType, this.isGearIconClicked, this.isOrgLevel).subscribe((response) => {
      this.roles = response;
      this.ngxLoader.stop(ngxLoaderKey);
    }, (response) => this.toastService.stopLoadingAndShowError(response,
      'Unable to load roles!', ngxLoaderKey));
    this.loadUsers();
  }

  loadCountryInfo(ngxLoaderKey) {
    if (this.orgType == "External") return;

    this.countryService.getAllCountries().subscribe(
      (response) => {
        this.countriesList = response;
        this.ngxLoader.stop(ngxLoaderKey);
      }
    );

    this.countryService.getUserCountriesForOrg().subscribe(
      (response) => {
        this.userCountriesList = response;
        this.tabulateUsers(this.userList);
        this.ngxLoader.stop(ngxLoaderKey);
      }
    );
  }

  showResendInvtnAndResetPwd() {
    if (this.orgType == "External") {
      this.isResendInvitationVisible = true;
    }
    else if (this.orgType == "Internal") {
      if (this.isGearIconClicked) {
        this.isResendInvitationVisible = false;
      }
      else {
        this.isResendInvitationVisible = true;
      }
    }
  }

  emailExist() {
    const emailExist = this.userList.filter(userlist => userlist.email == this.formGroup.get('userEmail').value);
    if (emailExist.length == 1) {
      const loadingKey = 'Email already exist!';
      this.toastService.stopLoadingAndShowError(
        'Email already exist!', loadingKey);
    }
    else {
      this.authorizationService.checkUserExists(this.formGroup.get('userEmail').value)
        .subscribe((response) => {
          if (response == true) {
            this.isEmailExist = true;
            const loadingKey = 'Email already exist!';
            this.toastService.stopLoadingAndShowError(
              'Email already exist!', loadingKey);
          }
          else {
            this.isEmailExist = false;
          }
        },
          catchError((error: HttpErrorResponse) => {
            this.isEmailExist = false;
            let errorMessage: string;
            if (error.error instanceof ErrorEvent) {
              // client-side error
              errorMessage = `${error.error.message}`;
            } else {
              // server-side error
              errorMessage = `Status: ${error.status}\nMessage: ${error.message}`;
            }
            this.loggerService.logError('this.authorizationService.getUser - user email exits check: Error: ', errorMessage);
            return throwError(error);
          }));
    }
  }

  tabulateUsers(users: OrgUsersAndRoles[]) {
    let usersTableData: ManagedUserInfo[] = [];
    users.forEach((user: OrgUsersAndRoles) => {
      let userCountries = this.userCountriesList.filter(userCountry => userCountry.userId === user.userId);
      let countries = this.countriesList.filter(country => (userCountries.filter(userCountry => userCountry.countryId === country.countryId).length > 0));
      let countryCodes = [];
      countries.forEach((country: Country) => { countryCodes.push(country.countryCode); });

      usersTableData.push({
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        roleDescription: user.roleDescription,
        enabled: user.enabled,
        countries: countryCodes.join(', '),
        roleId: user.roleId,
        organizationId: user.organizationId,
        userId: user.userId,
        orgName: user.orgName,
        isManagementRestricted: user.isManagementRestricted
      });
    });

    this.userList = users;
    this.setUsersToTableData(usersTableData);
    this.buildFilterRolesFromUsers();
  }

  loadUsers() {
    const ngxLoaderKey = 'load-users';
    this.ngxLoader.start(ngxLoaderKey);

    this.loadCountryInfo(ngxLoaderKey);

    this.userService.getUsersAndRolesForOrg(this.isOrgLevel? this.selectedSiteId : this.paramOrgId, this.orgType, this.isGearIconClicked)
      .subscribe((users) => {
        this.ngxLoader.stop(ngxLoaderKey);

        this.tabulateUsers(users);
      },
        catchError((error: HttpErrorResponse) => {
          let errorMessage: string;
          if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `${error.error.message}`;
          } else {
            // server-side error
            errorMessage = `Status: ${error.status}\nMessage: ${error.message}`;
          }
          this.toastService.stopLoadingAndShowError(error, 'Error while loading users!', ngxLoaderKey);
          this.loggerService.logError('this.userService.getUsersAndRolesForOrg-LoadUser: Error: ', errorMessage);
          return throwError(error);
        }));
  }

  applyFilter(newFilter: FilterData = {}) {
    this.filter = { ...this.filter, ...newFilter };
    this.isSelected = this.filter.roleId;
    this.dataSource.filter = Math.random().toString(); // hack to trigger filter refresh
  }

  /** To create user for an organization */
  addUser() {
    if (this.formGroup.valid) {
      const emailExist = this.userList.filter(userlist => userlist.email == this.formGroup.get('userEmail').value);
      if (emailExist.length == 1 || this.isEmailExist) {
        const loadingKey = 'Email already exist!';
        this.toastService.stopLoadingAndShowError(
          'Email already exist!', loadingKey);
      }
      else {
        const loadingKey = 'add-user';

        const orgUser: OrgUser = {
          ...this.formGroup.getRawValue(),
          orgId: this.isOrgLevel ? this.formGroup.get('siteId').value : this.paramOrgId,
          userCountries: this.isUserTypeWithCountries ? this.formGroup.get('countryIds').value : []
        };

        this.ngxLoader.start(loadingKey);
        this.userService.createUserWithRole(orgUser,this.orgType, this.isGearIconClicked).subscribe(() => {
          this.ngxLoader.stop(loadingKey);
          this.toastService.openToast('New user created');
          this.reset();
          this.loadUsers();
        },
          catchError((error: HttpErrorResponse) => {
            let errorMessage: string;
            if (error.error instanceof ErrorEvent) {
              // client-side error
              errorMessage = `${error.error.message}`;
            } else {
              // server-side error
              errorMessage = `Status: ${error.status}\nMessage: ${error.message}`;
            }
            this.toastService.stopLoadingAndShowError(error, 'Error while creating user!', loadingKey);
            this.loggerService.logError('createUserWithRole: Error: ', errorMessage);
            return throwError(error);
          })
        );
      }
    }
  }

  inactiveUsers() {
    const loadingKey = 'inactive-users';
    this.ngxLoader.start(loadingKey);

    const requests = this.selection.selected
      .map(({ userId, enabled, ...user }) =>
        this.userService.updateById(userId, { ...user, enabled: !enabled }),
      );

    forkJoin(requests).subscribe(() => {
      this.ngxLoader.stop(loadingKey);
      this.toastService.openToast('Users Inactivated');
      this.loadUsers();
    }, (response) => this.toastService.stopLoadingAndShowError(response,
      `Error while inactivate users!`, loadingKey,
    ));
  }

  getUserCountryIds(userId: string) {
    let userCountries = this.userCountriesList.filter(userCountry => userCountry.userId === userId);
    let res: number[] = []
    userCountries.forEach((userCountry: UserCountry) => { res.push(userCountry.countryId) });
    return res;
  }

  editUser(user: ManagedUserInfo) {
    if (user) {
      this.editingUser = { ...user };
      this.editUserFormGroup.patchValue({
        lastName: user.lastName,
        firstName: user.firstName,
        roleId: user.roleId,
        siteId: user.organizationId,
        countryIds: this.getUserCountryIds(user.userId)
      });
      this.applyFilter(this.filter);
    } else {
      this.editingUser = null;
      // Clear the search input
      const searchInput = document.getElementById('UserManagementSearch') as HTMLInputElement;
      if (searchInput) {
        searchInput.value = '';
      }
      // Clear the role select
      this.selectedRoleId = '';
      this.isSelected = '';

      this.applyFilter({ text: '', organizationId: '', roleId: this.isSelected });
    }
  }

  cancelEditUser(){
    this.editingUser = null;
    this.applyFilter(this.filter);
    this.resetEdit();
  }

  changeRole() {
    const user: OrgUsersAndRoles = {
      ...this.editingUser,
      ...this.editUserFormGroup.getRawValue(),
    };

    const userRole: OrgUserRoles = {
      organizationId: this.paramParentOrgId,
      userId: user.userId,
      roles: [user.roleId]
    };

    const loadingKey = 'change-role';
    this.ngxLoader.start(loadingKey);

    this.userService.updateUserRole(userRole, this.orgType, this.isGearIconClicked).subscribe({
      complete: () => {
        this.ngxLoader.stop(loadingKey);
        this.toastService.openToast('Role Updated Successfully!');
        this.loadUsers();
      },
      error: (error: HttpErrorResponse) => {
        let errorMessage: string;
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `${error.error.message}`;
        } else {
          // server-side error
          errorMessage = `Status: ${error.status}\nMessage: ${error.message}`;
        }
        this.toastService.stopLoadingAndShowError(error, 'Error while updating role!', loadingKey);
        this.loggerService.logError('updateUserRole: Error: ', errorMessage);
        return throwError(() => error);
      }
    });
  }

  changeCountries(dto: UserCountries) {
    const loadingKey = 'change-countries';
    this.ngxLoader.start(loadingKey);

    this.userService.updateUserCountries(dto)
      .subscribe({
        complete: () => {
          this.ngxLoader.stop(loadingKey);
          this.toastService.openToast('Countries Updated Successfully!');
          this.loadUsers();
          this.editUser(null);
        },
        error: (error: HttpErrorResponse) => {
          let errorMessage: string;
          if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `${error.error.message}`;
          } else {
            // server-side error
            errorMessage = `Status: ${error.status}\nMessage: ${error.message}`;
          }
          this.toastService.stopLoadingAndShowError(error, 'Error while updating user details!', loadingKey);
          this.loggerService.logError('updateUserDetails: Error: ', errorMessage);
          return throwError(() => error);
        }
      });
  }

  changeInternalUserDetails() {
    this.changeRole();

    const userId: string = this.editingUser.userId;
    const countryIds: number[] = this.editingCountries
      ? this.editUserFormGroup.get('countryIds').value
      : [];

    this.changeCountries({ userId, countryIds });
    this.resetEdit();
  }

  changeUserDetails() {
    const user: OrgUsersAndRoles = {
      ...this.editingUser,
      ...this.editUserFormGroup.getRawValue(),
      organizationId: this.editUserFormGroup.get('siteId').value
    };

    const userOrgRole: OrgUserRole = {
      orgId: user.organizationId,
      userId: user.userId,
      roleId: user.roleId,
      userFirstName : user.firstName,
      UserLastName : user.lastName
    };

    const loadingKey = 'change-role';
    this.ngxLoader.start(loadingKey);

    this.userService.updateUserDetails(userOrgRole).subscribe(() => {
      this.ngxLoader.stop(loadingKey);
      this.toastService.openToast('User details Updated Successfully!');
      this.loadUsers();
      this.editUser(null);
    },
      catchError((error: HttpErrorResponse) => {
        let errorMessage: string;
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `${error.error.message}`;
        } else {
          // server-side error
          errorMessage = `Status: ${error.status}\nMessage: ${error.message}`;
        }
        this.toastService.stopLoadingAndShowError(error, 'Error while updating role!', loadingKey);
        this.loggerService.logError('updateUserRole: Error: ', errorMessage);
        return throwError(error);
      })
    );
  }

  changeUserStatus({ userId, enabled, email, ...user }: OrgUsersAndRoles) {
    const loadingKey = 'change-user-status';
    this.ngxLoader.start(loadingKey);

    const request = enabled ? this.userService.deactivateUser(userId,this.orgType, this.isGearIconClicked) : this.userService.activateUser(userId,this.orgType, this.isGearIconClicked);
    request.subscribe(() => {
      this.ngxLoader.stop(loadingKey);
      const message = enabled ? 'User inactivated' : 'User reactivated';
      this.toastService.openToast(message);
      this.inActiveGroup = { groupName: 'Inactive Users', htmlId: 'UserManagementInactiveUsers', expanded: true };
      this.loadUsers();

      this.setInactivatedUser(enabled ? { userId, enabled: false, ...user } : null);

      //Disabling Active Report Subscriptions for the user
      if (enabled) {
        this.reportService.DisableAllSubscriptions(email).subscribe(() => {
        },
          catchError((error: HttpErrorResponse) => {
            let errorMessage: string;
            if (error.error instanceof ErrorEvent) {
              // client-side error
              errorMessage = `${error.error.message}`;
            } else {
              // server-side error
              errorMessage = `Status: ${error.status}\nMessage: ${error.message}`;
            }
            this.toastService.stopLoadingAndShowError(error, 'Error while disabling active report subscriptions!', loadingKey);
            this.loggerService.logError('DisableAllSubscriptions: Error: ', errorMessage);
            return throwError(error);
          })
        );
      }
    },
      catchError((error: HttpErrorResponse) => {
        let errorMessage: string;
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `${error.error.message}`;
        } else {
          // server-side error
          errorMessage = `Status: ${error.status}\nMessage: ${error.message}`;
        }
        this.toastService.stopLoadingAndShowError(error, `Error while ${enabled ? 'inactivate' : 'reactivate'} user!`, loadingKey);
        this.loggerService.logError('changeUserStatus: Error: ', errorMessage);
        return throwError(error);
      })
    );
  }

  setInactivatedUser(user) {
    this.inactivatedUser = user;
    clearTimeout(this.inactivatedUserPanelTimeout);
    if (user) {
      this.inactivatedUserPanelTimeout = setTimeout(() => this.inactivatedUser = null, 5000);
    }
  }

  resendUserInvitation(userId: string) {
    const loadingKey = 'resend-invitation-user';
    this.ngxLoader.start(loadingKey);

    this.userService.resendInvitation(userId).subscribe(() => {
      this.ngxLoader.stop(loadingKey);
      this.toastService.openToast('Resend Invitation successful!');
    },
      catchError((error: HttpErrorResponse) => {
        let errorMessage: string;
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `${error.error.message}`;
        } else {
          // server-side error
          errorMessage = `Status: ${error.status}\nMessage: ${error.message}`;
        }
        this.toastService.stopLoadingAndShowError(error, `Error while resend invitation email!`, loadingKey);
        this.loggerService.logError('resendUserInvitation: Error: ', errorMessage);
        return throwError(error);
      })
    );
  }

  resetPassword(userId: string) {
    const loadingKey = 'reset-password';
    this.ngxLoader.start(loadingKey);

    this.userService.resetPassword(userId).subscribe(() => {
      this.ngxLoader.stop(loadingKey);
      this.toastService.openToast('Reset Password successful!');
    },
      catchError((error: HttpErrorResponse) => {
        let errorMessage: string;
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `${error.error.message}`;
        } else {
          // server-side error
          errorMessage = `Status: ${error.status}\nMessage: ${error.message}`;
        }
        this.toastService.stopLoadingAndShowError(error, `Error while reset password!`, loadingKey);
        this.loggerService.logError('resetPassword: Error: ', errorMessage);
        return throwError(error);
      })
    );
  }

  reset() {
    this.formDirective.resetForm();
    this.formGroup.reset({
      userLastName: '',
      userFirstName: '',
      userEmail: '',
      role: '',
      userCountries: []
    });
    this.availableAddCountries = [];
  }

  resetEdit() {
    this.editUserFormGroup.reset({
      name: '',
      email: '',
      roleId: '',
      siteId: '',
      countryIds: []
    });
  }

  userCountriesById(id: string) {
    let res: number[] = [];
    this.userCountriesList.forEach((userCountry) => {
      if (userCountry.userId === id) res.push(userCountry.countryId);
    });
    return res;
  }

  showEditUser(user: OrgUsersAndRoles,id) {
    if (user) {
      this.editingUser = { ...user };
      this.editUserFormGroup.patchValue({
        lastName: user.lastName,
        firstName: user.firstName,
        roleId: user.roleId,
        name: user.lastName.toUpperCase() + ' - ' + user.firstName,
        email: user.email,
        siteId: user.organizationId
      });
      this.editUserFormGroup.get('countryIds').setValue(this.userCountriesById(user.userId));

      document.getElementById("matedit" + id).style.display = "block";
      document.getElementById("matcard" + id).style.display = "none";

    } else {
      this.editingUser = null;
    }
    this.applyFilter({ text: '', organizationId: '', roleId: this.isSelected });
  }

  hideEditUser(index) {
    document.getElementById("matedit" + index).style.display = "none";
    document.getElementById("matcard" + index).style.display = "flex";
    this.editingUser = null;
  }

  get hasUnsavedEdit(): boolean {
    return this.editUserFormGroup.dirty;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected ?
      this.selection.clear() :
      this.selectableRows.forEach(row => this.selection.select(row));
  }

  toggleRow(row) {
    if (row.userId && !(this.editingUser && this.editingUser.userId === row.userId)) {
      this.selection.toggle(row);
    }
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: OrgUsersAndRoles): string {
    if (!row) {
      return `${this.isAllSelected ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.userId + 1}`;
  }

  /**
   * Custom filter for the table
   *
   * Note that this function don't use `this.dataSource.filter` for filter
   * because it's only support for text, we need filter by columns with custom logic
   * Change `this.dataSource.filter` to another value to trigger filter
   */
  private customFilterPredicate(data: TableRow): boolean {
    const isVisible = data.enabled ? this.activeGroup.expanded : this.inActiveGroup.expanded;

    const filterDataRow = () => {
      if (!isVisible) { return false; }
      const transformedFilter = this.filter.text.trim().toLowerCase();
      const searchStr = `${data.firstName} ${data.lastName}◬${data.email}`.toLowerCase();
      return searchStr.indexOf(transformedFilter) !== -1 &&
        (this.filter.roleId ? data.roleId === this.filter.roleId : true);
    };

    const filterTableGroup = () => this.isGroup(null, data);
    const filterNoDataRow = () => this.isNoDataRow(null, data) && isVisible;

    return filterTableGroup() || filterNoDataRow() || filterDataRow();
  }

  groupHeaderClick(row) {
    row.expanded = !row.expanded;
    this.applyFilter();
  }

  isGroup(index, item): boolean {
    return 'groupName' in item;
  }

  isNoDataRow(index, item): boolean {
    return 'noDataText' in item;
  }

  isEditingRow(index, item): boolean {
    return this.editingUser && this.editingUser.userId === item.userId;
  }

  getId(item: TableRow, name: string) {
    return `UserManagement${item.enabled ? 'ActiveUsers' : 'InactiveUsers'}${name}${item.index}`;
  }

  getName(user: OrgUsersAndRoles) {
    return [
      user.lastName.toUpperCase(),
      user.firstName && user.lastName ? ', ' : '',
      user.firstName ? (user.firstName[0].toUpperCase() + user.firstName.substring(1)) : '',
    ].join('');
  }

  private setUsersToTableData(users: ManagedUserInfo[]) {
    this.selection.clear(); 

    const activeUsers = users.filter(({ enabled }) => enabled)
      .map((data, index) => ({ ...data, index })).sort((a, b) => { return compare(a?.lastName, b?.lastName, true); });
    const inActiveUsers = users.filter(({ enabled }) => !enabled)
      .map((data, index) => ({ ...data, index })).sort((a, b) => { return compare(a?.lastName, b?.lastName, true); });

    this.dataSource.data = [
      this.activeGroup,
      ...(activeUsers.length ? activeUsers :
        [{ noDataText: 'No active users', enabled: true } as NoDataRow]
      ),
      this.inActiveGroup,
      ...(inActiveUsers.length ? inActiveUsers :
        [{ noDataText: 'No inactive users', enabled: false } as NoDataRow]
      ),
    ];
    this.applyFilter({ text: '', organizationId: '', roleId: this.isSelected });
  }

  sortData(sort: Sort) {

    this.selection.clear();

    this.activeUsers = this.userList.filter(({ enabled }) => enabled)
      .map((data, index) => ({ ...data, index }));
    this.inActiveUsers = this.userList.filter(({ enabled }) => !enabled)
      .map((data, index) => ({ ...data, index }));

    const isAsc = sort.direction === 'asc';

    this.activeUsers = this.activeUsers.sort((a, b) => {
      switch (sort.active) {
        case 'lastName':
          return compare(a?.lastName, b?.lastName, isAsc);
        case 'email':
          return compare(a?.email, b?.email, isAsc);
        case 'roleName':
          return compare(a?.roleName, b?.roleName, isAsc);
        default:
          return 0;
      }
    });

    this.inActiveUsers = this.inActiveUsers.sort((a, b) => {
      switch (sort.active) {
        case 'lastName':
          return compare(a?.lastName, b?.lastName, isAsc);
        case 'email':
          return compare(a?.email, b?.email, isAsc);
        case 'roleName':
          return compare(a?.roleName, b?.roleName, isAsc);
        default:
          return 0;
      }
    });

    this.dataSource.data = [
      this.activeGroup,
      ...(this.activeUsers.length ? this.activeUsers :
        [{ noDataText: 'No active users', enabled: true } as NoDataRow]
      ),
      this.inActiveGroup,
      ...(this.inActiveUsers.length ? this.inActiveUsers :
        [{ noDataText: 'No inactive users', enabled: false } as NoDataRow]
      ),
    ];

    this.applyFilter({ text: '', organizationId: '', roleId: this.isSelected });
  }
}

function compare(a: string, b: string, isAsc: boolean) {
  return (a?.toLocaleLowerCase() < b?.toLocaleLowerCase() ? -1 : 1) * (isAsc ? 1 : -1);
}
